import { parseSensorPacket } from "@/lib/sensorPacket";

export class BluetoothLineBuffer {
  private buffer = "";
  private awaitingLineSync = true;

  constructor(
    private readonly onLine: (line: string) => void,
    private readonly logLabel: string
  ) {}

  reset() {
    this.buffer = "";
    this.awaitingLineSync = true;
  }

  pushChunk(chunk: string) {
    this.buffer += chunk;

    if (this.awaitingLineSync) {
      const syncIndex = this.buffer.indexOf("\n");
      if (syncIndex === -1) return;

      const firstFrame = this.buffer.slice(0, syncIndex);
      this.buffer = this.buffer.slice(syncIndex + 1);
      this.awaitingLineSync = false;
      this.emitLine(firstFrame);
    }

    const lines = this.buffer.split("\n");
    this.buffer = lines.pop() ?? "";
    for (const raw of lines) {
      this.emitLine(raw);
    }
  }

  private emitLine(raw: string) {
    const line = raw.trim();
    if (!line) return;
    if (!parseSensorPacket(line)) {
      return;
    }

    try {
      this.onLine(line);
    } catch (error) {
      console.warn(`[${this.logLabel}] Line handler error:`, error);
    }
  }
}

export function encodeBluetoothLine(encoder: TextEncoder, line: string) {
  return encoder.encode(line.endsWith("\n") ? line : `${line}\n`);
}
